
export const setNavigationState = (pageId, stage) => {
  localStorage.setItem('navigationState', JSON.stringify({ pageId, stage }));
};

export const getNavigationState = () => {
  const state = localStorage.getItem('navigationState');
  return state ? JSON.parse(state) : null;
};

export const clearNavigationState = () => {
  localStorage.removeItem('navigationState');
};
export const setSuccessFlag = (pageId, isActive) => {
  const successFlags = JSON.parse(localStorage.getItem('successFlags')) || [];

  const index = successFlags.findIndex(flag => flag.pageId === pageId);

  if (index !== -1) {
    successFlags[index].isActive = isActive;
  } else {
    successFlags.push({ pageId, isActive });
  }
  localStorage.setItem('successFlags', JSON.stringify(successFlags));
};

export const getSuccessFlag = (pageId) => {
  const successFlags = JSON.parse(localStorage.getItem('successFlags')) || [];
  const flag = successFlags.find(flag => flag.pageId === pageId);
  return flag ? flag.isActive : false;
};

export const clearSuccessFlag = (pageId) => {
  const successFlags = JSON.parse(localStorage.getItem('successFlags')) || [];
  const updatedFlags = successFlags.filter(flag => flag.pageId !== pageId);
  localStorage.setItem('successFlags', JSON.stringify(updatedFlags));
};
